import React from "react";
import { useSelector } from 'react-redux';
import { useTranslation, Trans } from "react-i18next";

import {
  Card,
  Image,
  Button,
  Space
} from '@lockerpm/design';

import images from "../../assets/images";
import global from "../../config/global";
import storeActions from "../../store/actions";
import onboardingServices from "../../services/onboarding";

const WelcomeBanner = () => {
  const { t } = useTranslation();
  const { WelcomeImg } = images;

  const welcomeVisible = useSelector((state) => state.onboarding.welcomeVisible)

  const handleSkip = async () => {
    await onboardingServices.update_onboarding({ welcome: true });
    global.store.dispatch(storeActions.updateWelcomeVisible(false));
  }
  
  return (
    <>
      {
        !!welcomeVisible && <div
          className="welcome-banner mb-4"
          style={{ height: 'auto' }}
        >
          <Card>
            <div className="flex items-center justify-between">
              <div>
                <div className="text-lg font-semibold mb-2">
                  {t('welcome.title')}
                </div>
                <div className="text-black-600">
                  {t('welcome.text1')}
                  <br />
                  {t('welcome.text2')}
                  <br />
                  <p>
                    <Trans
                      i18nKey={'welcome.text3'}
                      components={{
                        a: <a href={global.urls.CHROME_EXTENSION_URL} target="_blank"/>
                      }}
                    />
                  </p>
                </div>
                <Space className='mt-4'>
                  <Button
                    onClick={() => handleSkip()}
                  >
                    {t('button.close')}
                  </Button>
                </Space>
              </div>
              <div>
                <Image
                  src={WelcomeImg}
                  preview={false}
                />
              </div>
            </div>
          </Card>
        </div>
      }
    </>
  );
}

export default WelcomeBanner;